module.exports = __webpack_public_path__ + "static/details-3-e70f5f80fd0fb5a6cfaec991ce58b929.jpg";